/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Alloy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EventStatus = 'Creating' | 'Active' | 'Paused' | 'Ended' | 'Expired' | 'Planning' | 'Applying' | 'Failed' | 'Ending';

export const EventStatus = {
    Creating: 'Creating' as EventStatus,
    Active: 'Active' as EventStatus,
    Paused: 'Paused' as EventStatus,
    Ended: 'Ended' as EventStatus,
    Expired: 'Expired' as EventStatus,
    Planning: 'Planning' as EventStatus,
    Applying: 'Applying' as EventStatus,
    Failed: 'Failed' as EventStatus,
    Ending: 'Ending' as EventStatus
};

